import { useState } from 'react';

export default function FeatureComparison() {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wide mb-4">
            Why Basetao Spreadsheet
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            What Is Basetao Spreadsheet?
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            Basetao Spreadsheet is a structured product research resource designed to help shoppers discover products faster. Instead of searching thousands of listings manually, users can organize product links, categories, prices, QC information, shipping options, and buying notes. Our guides help beginners and experienced shoppers make smarter decisions.
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-6 py-4 font-semibold text-foreground-900">Feature</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-500">Normal Search</th>
                <th className="text-left px-6 py-4 font-semibold text-primary-600">Basetao Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Product Discovery', normal: 'Slow', sheet: 'Fast' },
                { feature: 'Organization', normal: 'Low', sheet: 'High' },
                { feature: 'Product Comparison', normal: 'Difficult', sheet: 'Easy' },
                { feature: 'QC Research', normal: 'Manual', sheet: 'Structured' },
                { feature: 'Time Saving', normal: 'Low', sheet: 'High' },
              ].map((row) => (
                <tr key={row.feature} className="border-t border-background-200/70 hover:bg-background-50/70 transition-colors">
                  <td className="px-6 py-4 font-medium text-foreground-900">{row.feature}</td>
                  <td className="px-6 py-4 text-foreground-500">{row.normal}</td>
                  <td className="px-6 py-4 text-primary-600 font-medium">{row.sheet}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {!expanded && (
          <div className="text-center mt-8">
            <button
              onClick={() => setExpanded(true)}
              className="px-5 py-2.5 rounded-lg bg-secondary-100 text-secondary-700 text-sm font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="flex items-center gap-2">
                See More Benefits
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </span>
            </button>
          </div>
        )}

        {expanded && (
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { icon: 'ri-time-line', title: 'Save Hours of Research', desc: 'Find products in minutes instead of spending hours scrolling through endless listings.' },
              { icon: 'ri-scales-3-line', title: 'Compare Products Easily', desc: 'Side-by-side comparison of prices, quality, and shipping options across categories.' },
              { icon: 'ri-money-dollar-circle-line', title: 'Understand Shipping Costs', desc: 'Get clear breakdowns of shipping methods, costs, and estimated delivery times.' },
              { icon: 'ri-discount-percent-line', title: 'Find Better Deals', desc: 'Access verified coupons, discount codes, and promotional offers updated regularly.' },
              { icon: 'ri-error-warning-line', title: 'Avoid Shopping Mistakes', desc: 'Learn from community experiences and avoid common pitfalls in product research.' },
            ].map((item) => (
              <div key={item.title} className="p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200/70 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-4">
                  <i className={`${item.icon} text-lg text-accent-600`}></i>
                </div>
                <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}